import { ShieldCheck } from "@phosphor-icons/react";

/**
 * Compact pill toggle that filters claim sources down to IFCN fact-checkers.
 * Stateless — parent owns `enabled` + `onChange`.
 */
export default function FactCheckerToggle({ enabled, onChange, matchCount, totalCount }) {
  return (
    <button
      type="button"
      onClick={() => onChange(!enabled)}
      data-testid="fact-checker-toggle"
      aria-pressed={enabled}
      className={`inline-flex items-center gap-2 border font-mono-plex text-[10px] font-semibold px-2.5 py-1 transition-colors ${
        enabled
          ? "border-emerald-600 bg-emerald-600 text-white"
          : "border-zinc-300 bg-white text-zinc-700 hover:border-zinc-900 hover:text-zinc-950"
      }`}
    >
      <ShieldCheck weight={enabled ? "fill" : "duotone"} className="w-3.5 h-3.5" />
      FACT-CHECKERS ONLY
      {typeof matchCount === "number" && (
        <span className={`ml-1 rounded-sm px-1 ${enabled ? "bg-white/25 text-white" : "bg-zinc-100 text-zinc-600"}`}>
          {matchCount}/{totalCount}
        </span>
      )}
    </button>
  );
}
